module.exports = __webpack_public_path__ + "static/media/chelohara_lettertoalex.111ffa5a.png";